import { render, staticRenderFns } from "./DFormAttachment.vue?vue&type=template&id=04e200e3&scoped=true&"
import script from "./DFormAttachment.vue?vue&type=script&lang=js&"
export * from "./DFormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e200e3",
  null
  
)

export default component.exports